import {
  drawerWidth,
  headerHeight,
  transition,
  // boxShadow,
  defaultFont,
  primaryColor,
  infoColor,
  successColor,
  warningColor,
  dangerColor,
  whiteColor,
  // grayColor,
  hexToRgb
} from "assets/jss/index.js";


const sidebarStyle = theme => ({
  drawerPaper: {
    border: "none",
    position: "fixed",
    top: headerHeight,
    bottom: "0",
    left: "0",
    zIndex: "100",
    backgroundColor: "#3c4b64",
    width: drawerWidth,
    height: "100%",
    boxShadow: "none !important",
    ...transition,
  },
  logo: {
    position: "relative",
    padding: "15px",
    zIndex: "4",
    backgroundColor: "#303c55",
    borderBottom: "solid 1px rgba(255,255,255,.25)"
  },
  logoLink: {
    ...defaultFont,
    padding: "10px 0",
    display: "block",
    fontSize: "20px",
    textAlign: "left",
    fontWeight: "400",
    lineHeight: "20px",
    textDecoration: "none",
    backgroundColor: "transparent",
    "&,&:hover": {
      color: whiteColor
    }
  },
  logoImage: {
    width: "20px",
    display: "inline-block",
    maxHeight: "20px",
    marginLeft: "10px",
    marginRight: "15px"
  },
  img: {
    width: "35px",
    top: "22px",
    position: "absolute",
    verticalAlign: "middle",
    border: "0"
  },
  background: {
    position: "absolute",
    zIndex: "1",
    height: "100%",
    width: "100%",
    display: "block",
    top: "0",
    left: "0",
    backgroundSize: "cover",
    backgroundPosition: "center center",
  },
  list: {
    marginTop: "20px",
    paddingLeft: "0",
    paddingTop: "0",
    paddingBottom: "0",
    marginBottom: "0",
    listStyle: "none",
    position: "unset"
  },
  userList: {
    padding: 0,
    listStyle: "none",
    position: "unset"
  },
  collapseList: {
    marginTop: "0",
    marginBottom: "5px"
  },
  item: {
    position: "relative",
    display: "block",
    textDecoration: "none",
    margin: "10px 0",
    "&:hover,&:focus,&:visited,&": {
      color: whiteColor
    }
  },
  itemLink: {
    width: "auto",
    transition: "all 300ms linear",
    position: "relative",
    display: "flex",
    padding: "12px 10px 12px 15px",
    backgroundColor: "transparent",
    ...defaultFont,
    "&:hover": {
      outline: "none",
      backgroundColor: "rgba(255, 236, 248, 0.3)",
      boxShadow: "none"
    },
    "&,&:hover,&:focus": {
      color: "rgba(" + hexToRgb(whiteColor) + ", 0.8)"
    }
  },
  itemLinkCol: {
    padding: "7px 10px 7px 46px",
  },
  itemIcon: {
    width: "20px",
    height: "20px",
    fontSize: "20px",
    lineHeight: "20px",
    float: "left",
    marginRight: "12px",
    textAlign: "center",
    verticalAlign: "middle",
  },
  itemText: {
    ...defaultFont,
    margin: "0",
    lineHeight: "20px",
    fontSize: "13px",
  },
  whiteFont: {
    color: whiteColor
  },
  infoFont: {
    color: infoColor[1] + " !important"
  },
  purple: {
    backgroundColor: primaryColor[0],
    "&:hover,&:focus": {
      backgroundColor: primaryColor[0],
    }
  },
  blue: {
    backgroundColor: infoColor[0],
    "&:hover,&:focus": {
      backgroundColor: infoColor[0],
    }
  },
  green: {
    backgroundColor: successColor[0],
    "&:hover,&:focus": {
      backgroundColor: successColor[0],
    }
  },
  orange: {
    backgroundColor: warningColor[0],
    "&:hover,&:focus": {
      backgroundColor: warningColor[0],
    }
  },
  red: {
    backgroundColor: dangerColor[0],
    "&:hover,&:focus": {
      backgroundColor: dangerColor[0],
    }
  },
  sidebarWrapper: {
    position: "relative",
    height: "calc(100vh - 75px)",
    overflow: "auto",
    width: drawerWidth,
    zIndex: "4",
    overflowScrolling: "touch"
  },
  activePro: {
    [theme.breakpoints.up("md")]: {
      position: "absolute",
      width: "100%",
      bottom: "13px"
    }
  },


  user: {
    zIndex: "4",
    padding: "10px 0",
    position: "relative",
    backgroundColor: "#23303e",
    border: "1px solid #404854",
    borderRight: 0,
    borderLeft: 0,
  },
  userCollapseButton: {
    margin: "0 5px",
    cursor: "pointer",
    "&:hover": {
      background: "none"
    }
  },
  caret: {
    marginTop: "13px",
    position: "absolute",
    right: "12px",
    transition: "all 150ms ease-in",
    display: "inline-block",
    width: "0",
    height: "0",
    marginLeft: "2px",
    verticalAlign: "middle",
    borderTop: "4px solid",
    borderRight: "4px solid transparent",
    borderLeft: "4px solid transparent"
  },
  caretActive: {
    transform: "rotate(180deg)"
  },
});

export default sidebarStyle;
